import { Body, FlexContainer, Icon } from "@/lib/main";
import { CSSProperties } from "react";

type Props = {
  count: number;
  handleCountChange: (countChange: number) => void;
};

export default function AddRemoveProduct({ count, handleCountChange }: Props) {
  const buttonStyle: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    border: "none",
    borderRadius: "var(--border-radius-2xs)",

    width: "1.75rem",
    minWidth: "1.75rem",
    height: "1.75rem",
    backgroundColor: "var(--color-background-overlay)",
  };

  return (
    <FlexContainer gap="lg">
      <button onClick={() => handleCountChange(-1)} style={buttonStyle}>
        <Icon name="minus" size="md" />
      </button>

      <Body fontWeight={600} textAlign="center">
        {count}
      </Body>

      <button onClick={() => handleCountChange(1)} style={buttonStyle}>
        <Icon name="plus" size="md" />
      </button>
    </FlexContainer>
  );
}
